import { useState, useCallback } from 'react';
import { RevxErrorMessage } from 'utils/errorCodes';

const useLoading = <P = any, T = any>(
  requestFn: (params?: P) => Promise<T>,
  successFn?: (res: T) => void,
  beforeReq?: () => void
): [
  loadingHandler: (params?: P) => void,
  loading: boolean,
  data: T | undefined,
  error: RevxErrorMessage | undefined
] => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<T>();
  const [error, setError] = useState<RevxErrorMessage | undefined>();

  const loadingHandler = useCallback(
    async (params?: P) => {
      setLoading(true);
      beforeReq?.();
      try {
        const res = await requestFn(params);
        setData(res);
        successFn?.(res);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [requestFn, beforeReq, successFn]
  );

  return [loadingHandler, loading, data, error];
};

export default useLoading;
